function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Modal, ModalBody, ModalFooter, ModalHeader, BasicModal, Button } from '@deephaven/components';
import { Pending, PromiseUtils, ValidationError } from '@deephaven/utils';
import Log from '@deephaven/log';
import { vsHome } from '@deephaven/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FileExplorer from "./FileExplorer.js";
import FileUtils from "./FileUtils.js";
import "./NewItemModal.css";
import FileExistsError from "./FileExistsError.js";
import FileNotFoundError from "./FileNotFoundError.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var log = Log.module('NewItemModal');
class NewItemModal extends PureComponent {
  static getValidationMessage(err) {
    if (err instanceof FileExistsError && err.info.type === 'directory') {
      return 'Error: Cannot overwrite existing directory';
    }
    return "".concat(err);
  }
  static handleError(err) {
    if (!PromiseUtils.isCanceled(err)) {
      log.error(err);
    }
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "inputRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "cancelableValidatePromise", void 0);
    _defineProperty(this, "cancelableExistingItemPromise", void 0);
    _defineProperty(this, "pending", new Pending());
    _defineProperty(this, "pathMap", new Map());
    _defineProperty(this, "isInitialLoad", true);
    this.handleModalSubmit = this.handleModalSubmit.bind(this);
    this.handleModalOpened = this.handleModalOpened.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleValidationError = this.handleValidationError.bind(this);
    this.handleOverwriteCancel = this.handleOverwriteCancel.bind(this);
    this.handleOverwriteConfirm = this.handleOverwriteConfirm.bind(this);
    this.handleExtensionChangeCancel = this.handleExtensionChangeCancel.bind(this);
    this.handleExtensionChangeConfirm = this.handleExtensionChangeConfirm.bind(this);
    this.handleBreadcrumbSelect = this.handleBreadcrumbSelect.bind(this);
    var defaultValue = props.defaultValue;
    var path = FileUtils.hasPath(defaultValue) ? FileUtils.getPath(defaultValue) : '/';
    this.state = {
      isSubmitting: false,
      path,
      prevExtension: FileUtils.getExtension(defaultValue),
      showExtensionChangeModal: false,
      showOverwriteModal: false,
      value: FileUtils.getBaseName(defaultValue)
    };
  }
  componentDidUpdate(prevProps, prevState) {
    var isOpen = this.props.isOpen;
    var prevIsOpen = prevProps.isOpen;
    var _this$state = this.state,
      value = _this$state.value,
      path = _this$state.path;
    if (!prevIsOpen && isOpen) {
      this.resetValue();
      this.isInitialLoad = true;
    }
    if (prevIsOpen && isOpen) {
      if (!this.isInitialLoad && (path !== prevState.path || value !== prevState.value)) {
        this.updateValidationStatus(path, value);
      }
      this.isInitialLoad = false;
    }
  }
  componentWillUnmount() {
    this.pending.cancel();
    if (this.cancelableValidatePromise) {
      this.cancelableValidatePromise.cancel();
    }
    if (this.cancelableExistingItemPromise) {
      this.cancelableExistingItemPromise.cancel();
    }
  }
  resetValue() {
    var _ref = this.props,
      defaultValue = _ref.defaultValue;
    var path = FileUtils.hasPath(defaultValue) ? FileUtils.getPath(defaultValue) : '/';
    this.setState({
      path,
      value: FileUtils.getBaseName(defaultValue),
      validationError: undefined,
      prevExtension: FileUtils.getExtension(defaultValue),
      isSubmitting: false
    });
  }
  getValidationPromise(path, name) {
    var checkExisting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (this.cancelableValidatePromise) {
      this.cancelableValidatePromise.cancel();
    }
    this.cancelableValidatePromise = PromiseUtils.makeCancelable(this.validateName(path, name, checkExisting));
    return this.cancelableValidatePromise;
  }
  validateName(path, name, checkExisting) {
    var _this = this;
    return _asyncToGenerator(function* () {
      FileUtils.validateName(name);
      var _this$props = _this.props,
        defaultValue = _this$props.defaultValue,
        storage = _this$props.storage;
      if (checkExisting) {
        var value = "".concat(path).concat(name);
        if (value !== defaultValue) {
          try {
            var existingFile = yield storage.info(value);
            throw new FileExistsError(existingFile);
          } catch (e) {
            if (!(e instanceof FileNotFoundError)) {
              throw e;
            }
            // There is no existing file, ignore
          }
        }
      }
      return name;
    })();
  }
  updateValidationStatus(path, newName) {
    this.getValidationPromise(path, newName).then(() => {
      this.setState({
        validationError: undefined
      });
    }).catch(this.handleValidationError).catch(NewItemModal.handleError);
  }
  handleModalOpened() {
    this.focusRenameInput();
  }
  handleModalSubmit() {
    this.submitModal();
  }
  handleChange(event) {
    var value = event.target.value;
    this.setState({
      value
    });
  }
  handleSelect(item) {
    log.debug('handleSelect', item);
    if (item.type === 'directory') {
      this.setState({
        path: FileUtils.makePath(item.filename)
      });
    } else {
      // Use selected item name and folder and focus the input
      var value = item.basename;
      var path = FileUtils.getPath(item.filename);
      this.setState({
        value,
        path
      }, () => {
        this.focusRenameInput();
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleKeyDown(e) {
    var key = e.key;
    e.stopPropagation();
    switch (key) {
      case 'Enter':
        {
          // Prevent form submit event
          e.preventDefault();
          this.submitModal();
          break;
        }
      case 'Escape':
        {
          e.preventDefault();
          var onCancel = this.props.onCancel;
          onCancel();
          break;
        }
      default:
    }
  }
  handleValidationError(err) {
    if (!(err instanceof ValidationError)) {
      throw err;
    }
    log.debug('Validation error', err);
    this.setState({
      validationError: err
    });
  }
  handleOverwriteCancel() {
    this.setState({
      showOverwriteModal: false,
      isSubmitting: false
    });
  }
  handleOverwriteConfirm() {
    this.setState({
      showOverwriteModal: false
    });
    var onSubmit = this.props.onSubmit;
    var _this$state2 = this.state,
      path = _this$state2.path,
      value = _this$state2.value;
    log.debug('handleOverwriteConfirm', path, value);
    onSubmit("".concat(path).concat(value), true);
  }
  handleExtensionChangeCancel() {
    log.debug('handleExtensionChangeCancel');
    this.setState(_ref2 => {
      var value = _ref2.value,
        prevExtension = _ref2.prevExtension;
      var newValue = FileUtils.replaceExtension(value, prevExtension);
      return {
        showExtensionChangeModal: false,
        value: newValue
      };
    });
    this.submitModal(true);
  }
  handleExtensionChangeConfirm() {
    log.debug('handleExtensionChangeConfirm');
    this.setState({
      showExtensionChangeModal: false
    });
    this.submitModal(true);
  }

  /**
   * Focus rename input and select name part for files, select all text for folders
   */
  focusRenameInput() {
    var input = this.inputRef.current;
    if (input) {
      var type = this.props.type;
      var value = input.value;
      var selectionEnd = type === 'directory' ? value.length : value.lastIndexOf('.');
      input.focus();
      input.setSelectionRange(0, selectionEnd > 0 ? selectionEnd : value.length);
    }
  }
  submitModal() {
    var skipExtensionCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    this.setState(_ref3 => {
      var prevExtension = _ref3.prevExtension,
        value = _ref3.value,
        path = _ref3.path;
      var _this$props2 = this.props,
        notifyOnExtensionChange = _this$props2.notifyOnExtensionChange,
        type = _this$props2.type;
      log.debug('submitModal', prevExtension, value);
      var newExtension = FileUtils.getExtension(value);
      if (notifyOnExtensionChange && !skipExtensionCheck && prevExtension !== null && prevExtension !== newExtension) {
        return {
          isSubmitting: false,
          showExtensionChangeModal: true,
          newExtension
        };
      }
      this.getValidationPromise(path, value, true).then(newItemName => {
        var onSubmit = this.props.onSubmit;
        onSubmit("".concat(path).concat(value));
      }).catch(e => {
        // Don't allow using existing names for folders
        // For files, prompt if they want to overwrite existing file
        if (e instanceof FileExistsError) {
          if (type !== 'directory' && e.info.type !== 'directory') {
            this.setState({
              showOverwriteModal: true
            });
            return;
          }
        }
        throw e;
      }).catch(e => {
        if (PromiseUtils.isCanceled(e)) {
          this.setState({
            isSubmitting: false
          });
        }
        throw e;
      }).catch(this.handleValidationError).catch(NewItemModal.handleError);
      return {
        isSubmitting: true,
        showExtensionChangeModal: false,
        newExtension: undefined
      };
    });
  }
  handleBreadcrumbSelect(directoryPath) {
    this.setState({
      path: directoryPath
    });
  }
  renderPathButtons(path) {
    var pathAsList = path.split('/');
    pathAsList.pop();
    return pathAsList.map((basename, index) => {
      var directoryPath = '';
      for (var i = 0; i < index; i += 1) {
        directoryPath += "".concat(pathAsList[i], "/");
      }
      directoryPath += "".concat(basename, "/");
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: "directory-breadcrumbs",
          onClick: () => this.handleBreadcrumbSelect(directoryPath),
          "aria-label": index === 0 ? 'Home' : undefined,
          icon: index === 0 ? /*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: vsHome,
            transform: "right-1.6"
          }) : undefined,
          tooltip: index === 0 ? 'Home' : undefined,
          children: basename
        }), "/"]
      }, directoryPath);
    });
  }
  render() {
    var _this$props3 = this.props,
      storage = _this$props3.storage,
      isOpen = _this$props3.isOpen,
      onCancel = _this$props3.onCancel,
      placeholder = _this$props3.placeholder,
      title = _this$props3.title,
      type = _this$props3.type;
    var _this$state3 = this.state,
      isSubmitting = _this$state3.isSubmitting,
      path = _this$state3.path,
      showExtensionChangeModal = _this$state3.showExtensionChangeModal,
      showOverwriteModal = _this$state3.showOverwriteModal,
      validationError = _this$state3.validationError,
      value = _this$state3.value,
      prevExtension = _this$state3.prevExtension,
      newExtension = _this$state3.newExtension;
    var isDirectory = type === 'directory';
    var prevExtensionText = FileUtils.fileExtensionToString(prevExtension);
    var newExtensionText = FileUtils.fileExtensionToString(newExtension);
    var submitBtnLabel = isDirectory ? 'Create' : 'Save';
    var nameInputLabel = isDirectory ? 'New folder name' : 'Save file as';
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Modal, {
        isOpen: isOpen,
        toggle: onCancel,
        onOpened: this.handleModalOpened,
        className: "modal-dialog-centered new-file-modal",
        children: [/*#__PURE__*/_jsx(ModalHeader, {
          toggle: onCancel,
          children: title
        }), /*#__PURE__*/_jsx(ModalBody, {
          children: /*#__PURE__*/_jsx("form", {
            children: /*#__PURE__*/_jsxs("div", {
              className: "d-flex flex-column new-file-modal-content",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "flex-grow-0 mb-4",
                children: [/*#__PURE__*/_jsx("label", {
                  htmlFor: "file-name-input",
                  children: nameInputLabel
                }), /*#__PURE__*/_jsx("input", {
                  id: "file-name-input",
                  type: "text",
                  autoComplete: "off",
                  autoCapitalize: "none",
                  autoCorrect: "off",
                  spellCheck: "false",
                  className: classNames('form-control', {
                    'is-invalid': validationError
                  }),
                  value: value,
                  placeholder: placeholder,
                  ref: this.inputRef,
                  onKeyDown: this.handleKeyDown,
                  onChange: this.handleChange
                }), validationError && /*#__PURE__*/_jsx("div", {
                  className: "invalid-feedback",
                  children: NewItemModal.getValidationMessage(validationError)
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "flex-grow-0",
                children: [/*#__PURE__*/_jsx("label", {
                  children: "Directory: /"
                }), this.renderPathButtons(path)]
              }), /*#__PURE__*/_jsx("div", {
                className: "flex-grow-1 file-explorer-container",
                children: /*#__PURE__*/_jsx(FileExplorer, {
                  onSelect: this.handleSelect,
                  storage: storage,
                  focusedPath: path
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsxs(ModalFooter, {
          children: [/*#__PURE__*/_jsx(Button, {
            kind: "secondary",
            onClick: onCancel,
            children: "Cancel"
          }), /*#__PURE__*/_jsx(Button, {
            kind: "primary",
            disabled: isSubmitting,
            onClick: this.handleModalSubmit,
            children: submitBtnLabel
          })]
        })]
      }), /*#__PURE__*/_jsx(BasicModal, {
        isOpen: showOverwriteModal,
        headerText: "Confirm overwrite",
        bodyText: "File with this name already exists, are you sure you want to overwrite it?",
        onCancel: this.handleOverwriteCancel,
        onConfirm: this.handleOverwriteConfirm,
        cancelButtonText: "Cancel",
        confirmButtonText: "Overwrite"
      }), /*#__PURE__*/_jsx(BasicModal, {
        isOpen: showExtensionChangeModal,
        headerText: "Confirm extension change",
        bodyText: "Are you sure you want to change extension from \"".concat(prevExtensionText, "\" to \"").concat(newExtensionText, "\"?"),
        onCancel: this.handleExtensionChangeCancel,
        onConfirm: this.handleExtensionChangeConfirm,
        cancelButtonText: "Keep \"".concat(prevExtensionText, "\""),
        confirmButtonText: "Use \"".concat(newExtensionText, "\"")
      })]
    });
  }
}
_defineProperty(NewItemModal, "defaultProps", {
  isOpen: false,
  defaultValue: '/',
  notifyOnExtensionChange: false,
  placeholder: '',
  onSubmit: (name, isOverwrite) => undefined,
  onCancel: () => undefined
});
export default NewItemModal;
//# sourceMappingURL=NewItemModal.js.map